import React from 'react'
import { GridCell } from '@progress/kendo-react-grid'
import Resx from '@/components/Resx'
import { isModified } from './common/isModified'

const modificationState = {
  unchanged: 0,
  inserted: 1,
  changed: 2,
  deleted: 3
}

function renderModificationCell (state) {
  switch (state) {
    case modificationState.inserted:
      return <td className='td-status'><span className='status status--1'><Resx name='Common.New' /></span></td>
    case modificationState.deleted:
      return <td className='td-status'><span className='status status--3'><Resx name='Common.Deleted' /></span></td>
    case modificationState.changed:
      return <td className='td-status'><span className='status status--2'><Resx name='Common.Changed' /></span></td>
    default:
      return <td className='td-status'><span className='status status--0'><Resx name='Common.Unchanged' /></span></td>
  }
}

class ModificationInfoCell extends GridCell {
  static omitFromExport = true
  render () {
    const { dataItem } = this.props
    const id = dataItem.id
    let state = isModified(dataItem) ? modificationState.changed : modificationState.unchanged
    if (dataItem.isDeleted) {
      state = modificationState.deleted
    } else if (id < 0 || dataItem.__IS_FILEATTACHMENT) {
      state = modificationState.inserted
    }
    return renderModificationCell(state)
  }
}

function createModificationInfoCell (approvalInfo, approvalName, items) {
  return class ModificationInfoCellWithApproval extends GridCell {
    static omitFromExport = true
    render () {
      const { dataItem } = this.props
      const id = dataItem.id
      const index = items.findIndex(x => x.id === id)

      // Check if item has approval entries (fallback when __isModified is missing)
      const hasApprovalChanges = () => {
        if (!approvalInfo || !approvalInfo.size) return false
        const prefix = `${approvalName}[${index}]`
        if (approvalInfo.some((_, key) => key.startsWith(prefix))) return true
        // Fallback: check by id match
        if (id > 0) {
          return approvalInfo.some((_, key) => {
            const match = key.match(new RegExp(`^${approvalName}\\[(\\d+)\\]`))
            if (match) {
              const approvalIndex = parseInt(match[1], 10)
              const itemAtApprovalIndex = items[approvalIndex]
              return itemAtApprovalIndex && itemAtApprovalIndex.id === id
            }
            return false
          })
        }
        return false
      }

      let state = (isModified(dataItem) || hasApprovalChanges()) ? modificationState.changed : modificationState.unchanged
      if (dataItem.isDeleted) {
        state = modificationState.deleted
      } else if (id < 0 || dataItem.__IS_FILEATTACHMENT) {
        state = modificationState.inserted
      }
      return renderModificationCell(state)
    }
  }
}

function createModificationInfoSourceCell (changes, approvalInfo, approvalName) {
  return class ModificationInfoSourceCell extends GridCell {
    static omitFromExport = true
    render () {
      const { dataItem } = this.props
      const id = dataItem.id
      const item = changes.find(x => x.id === id)
      const index = changes.findIndex(x => x.id === id)

      // Check if item has approval entries (fallback when __isModified is missing)
      const hasApprovalChanges = () => {
        if (!approvalInfo || !approvalInfo.size || index < 0) return false
        const prefix = `${approvalName}[${index}]`
        if (approvalInfo.some((_, key) => key.startsWith(prefix))) return true
        // Fallback: check by id match
        if (id > 0) {
          return approvalInfo.some((_, key) => {
            const match = key.match(new RegExp(`^${approvalName}\\[(\\d+)\\]`))
            if (match) {
              const approvalIndex = parseInt(match[1], 10)
              const itemAtApprovalIndex = changes[approvalIndex]
              return itemAtApprovalIndex && itemAtApprovalIndex.id === id
            }
            return false
          })
        }
        return false
      }

      let state = modificationState.unchanged
      if (item) {
        if (item.isDeleted) {
          state = modificationState.deleted
        } else if (isModified(item) || hasApprovalChanges()) {
          state = modificationState.changed
        }
      }
      return renderModificationCell(state)
    }
  }
}

export {
  ModificationInfoCell,
  createModificationInfoCell,
  createModificationInfoSourceCell
}



// WEBPACK FOOTER //
// ./src/components/changeRequests/modificationInfoCell.js